export const environment = {
  production: true,
  enableServiceWorkerModule: false,
  domainURL: 'https://stg.eservices.moccae.gov.ae',
  hostURL: 'https://stg-gateway.apim.moccae.gov.ae/',
  eServiceAPIHost:
    'https://stg-gateway.apim.moccae.gov.ae/EServiceAPI/1/DigitalServices/',
  DigitalServicesHostURL:
    'https://stg-gateway.apim.moccae.gov.ae/DigitalServicesAPI/v1/api/',
  hostAnimalCare: 'animalcare/1/',
  hostEdeAnimalCare: 'animalcare/1/',
  hostCustomer: 'customer/1/',
  hostCommon: 'common/1/',
  environment_name: 'staging',
  UAEPASSLoginURL:"https://stg-id.uaepass.ae/idshub/authorize?response_type=code&client_id=sandbox_stage&scope=urn:uae:digitalid:profile:general%20urn:uae:digitalid:profile:general:profileType%20urn:uae:digitalid:profile:general:unifiedId&state=ShNP22hyl1jUU2RGjTRkpg==&redirect_uri=UAEPASSREDIRECTURL&acr_values=urn:safelayer:tws:policies:authentication:level:low&ui_locales=",
  UAEPASSLogoutURL:"https://stg-id.uaepass.ae/idshub/logout?redirect_uri=https://stg.ds.moccae.gov.ae/login",
  UAEPassDefaultRedirectURL:"https://stg.ds.moccae.gov.ae/user-types",
  loginDomainURL: 'https://stg-gateway.apim.moccae.gov.ae/ds_uaepass/1/DigitalServices/',
  userProfileDomainURL: 'https://stg-gateway.apim.moccae.gov.ae/EServiceAPI/1/DigitalServices/',
  loginAPIManagerKey:"eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJzdWJzY3JpYmVkQVBJcyI6Ilt7XCJVSWRcIjpcImYzMTI0NTgxLTBlNWQtNGFjZC1iM2YxLTY5ODQ4MDhhYTM3M1wiLFwiUHJvamVjdE5hbWVcIjpcImRzX3VhZXBhc3NcIn1dIiwidHlwZSI6IngtbW9jY2FlLWFwaWtleSIsImlzcyI6Imh0dHBzOi8vYXBpbS5tb2NjYWUuZ292LmFlIiwiYXVkIjoiaHR0cHM6Ly9hcGltLm1vY2NhZS5nb3YuYWUifQ.dzsvFoXAPrQ1eX0MwvY4IyDvBOSnY0D3sBprS4I2DMg",
  loginAPIManagerKeyHeader: 'apikey',
  loggedInTimeout: 60,

  DigitalCertificatesAndPermitsHubURL: 'https://eservices.moccae.gov.ae/digitalcertificates/certificateverification.aspx?csrt=2379291188751290638',
  ElectronicRefundURL:'https://refund.adib.ae/portal/MOCCAE/portal/login',

  reportingHostURL:
    'https://stg-gateway.apim.moccae.gov.ae/DSReportAPI/v1/api/',
  fileServerURL: 'https://ds-boffice.ds.moccae.gov.ae:4443/files/',
  sharedFilesServiceURL: 'https://files.ds.moccae.gov.ae/files/',

  hostInspectionsURL:
    'https://stg-gateway.apim.moccae.gov.ae/InspectionAPI/1/DigitalServices/',

  customerPulseURL:
    'https://sandboxsurvey.customerpulse.gov.ae/destination/index.js',

  gateway: 'https://stg-gateway.apim.moccae.gov.ae/',
  websiteUrl: 'website/1/',
  loginURL: 'https://stg.ds.moccae.gov.ae/login',
  userTypesURL: 'https://stg.ds.moccae.gov.ae/user-types',
  homeURL: 'https://stg.ds.moccae.gov.ae/home',
  parentCookieDomainMOCCae: 'moccae.gov.ae',
  portalSearchUrl: 'https://www.moccae.gov.ae/Handlers/RESTApi.ashx',
  logoutUrl: 'https://stg-id.uaepass.ae/idshub/logout?redirect_uri=https://stg.ds.moccae.gov.ae/login',
  development: false,
  editProfileUrl:
    'https://stg.ds.moccae.gov.ae/profile',
  isEditProfileUrlES:true,
  portalUrl: 'https://www.moccae.gov.ae/',
  cacheBusterHash: '2.0',
  esMerchantUrl: 'https://stg.ds.moccae.gov.ae/confirmation-page-es',
  googleMapConfigs: {
    APIKey: 'AIzaSyD2TKA_xdUldeY7yOZxXgRPBeCNhdr1uXM',
    defaultLatitude: 24.453884,
    defaultLongitude: 54.3773594,
    defaultZoom: 15,
    defaultRadius: 300,
    defaultCircleColor: 'blue',
    defaultAddress: 'F93G+HW5 - Al Manhal - Abu Dhabi - United Arab Emirates',
  },
  formats: {
    EMIRATES_ID: /^784-[0-9]{4}-[0-9]{7}-[0-9]{1}$/,
  },
  gatewayPermanentToken: 'only for dev',
  appSettingsVersion: 1,
  downloadFileLink: 'FileManagement/DownloadFile.aspx?FileID={fileId}',
  ipInfoUrl: 'https://ipinfo.io/json?token=19e1f6e68b1737',
  oldWebSiteUrl: 'https://site.moccae.gov.ae/',
  liveChatScriptSource: {
    ar: '',
    en: '',
  },
  paymentConfirmation : {
    url: "https://payment-callback.2fo4vevaudxc.eu-de.codeengine.appdomain.cloud/api/payment-confirmation"
  }
};
